module.exports = __webpack_public_path__ + "b7450d0e6420462ca953ac4b91733af3.svg";